import type {ReactElement} from 'react';
import React, {useState} from 'react';
import {Dropdown} from '@Components/dropdown-v2';
import {ALIGNMENT_TYPE, DROPDOWN_POSITION} from '@Components/dropdown-v2/dropdown.types';
import {AddItemButton} from '@Components/poster-editor/components/poster-add-item-bar/components/add-item-button';
import {GA4EventName, trackPosterBuilderGA4Events} from '@Libraries/ga-events';
import {ADD_ITEM_BAR_POPUP_OFFSET, ADD_ITEM_BAR_TOP_OFFSET, type AddItemOptionsProps} from '@Components/poster-editor/components/poster-add-item-bar/poster-add-item-bar.types';
import {SlideshowDropdownList} from '@Components/poster-editor/components/poster-add-item-bar/components/slideshow-dropdown-list/slideshow-dropdown-list';

export function SlideshowDropdown({popupClassName = '', arrowClasses = '', isHidden = false}: AddItemOptionsProps): ReactElement<any> | null {
  const [isOpened, setIsOpened] = useState(false);

  if (isHidden) {
    return null;
  }

  return (
    <Dropdown
      id="toolbar-slideshow"
      key="toolbar-slideshow"
      alignment={ALIGNMENT_TYPE.RIGHT_END}
      selector={<AddItemButton isSelected={isOpened} text={window.i18next.t('pmwjs_slideshow')} icon="icon-slideshow" />}
      popup={<SlideshowDropdownList />}
      popUpHasCustomHeight
      maxHeight={500}
      popUpHasCustomWidth
      popupOffset={ADD_ITEM_BAR_POPUP_OFFSET}
      topOffset={ADD_ITEM_BAR_TOP_OFFSET}
      useDefaultArrow
      popupClassName={popupClassName}
      position={DROPDOWN_POSITION.FIXED}
      arrowClasses={arrowClasses}
      onOpen={(): void => {
        if (!isOpened) {
          trackPosterBuilderGA4Events(GA4EventName.LAYOUT_MENU_OPEN);
          setIsOpened(true);
        }
      }}
      onClose={(): void => {
        if (isOpened) {
          setIsOpened(false);
        }
      }}
    />
  );
}
